import { Box, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from '@mui/material';
import { ts } from 'src/utils/translate';
import { SchoolIcon } from 'src/icons/SchoolIcon';
import { OpenInNewIcon } from 'src/icons/OpenInNewIcon';
import { DEFAULT_SPACING } from 'src/theme/style-consts';
import { SOFTWARE_VERSION_NUMBER } from "src/utils/constants";

export function HelpMenu(props: { anchorEl: HTMLElement | null, handleClose: () => void }) {

  const open = Boolean(props.anchorEl);

  return (
      <Menu
          id="help-menu"
          anchorEl={props.anchorEl}
          open={open}
          onClose={props.handleClose}
      >
        <ListSubheader>{ts('help_support_title', 'Help & Support')}</ListSubheader>
        <MenuItem onClick={props.handleClose}>
          <ListItemButton disableGutters component='a' href='https://uplan.io/faq' target='_blank'>
            <ListItemIcon sx={{mr: DEFAULT_SPACING}}>
              <SchoolIcon fontSize='large'/>
            </ListItemIcon>
            <Box sx={{ paddingRight: '10px' }}>
              <ListItemText>
                {ts('faq', 'FAQ')} <OpenInNewIcon sx={{pt: '0.5rem'}} fontSize='small'/>
              </ListItemText>
              <ListItemText sx={{ width: '200px', whiteSpace: 'normal', fontSize: '1rem'}}>
                 {ts('faq_desc', 'Receive quick solutions to common questions.')}
              </ListItemText>
            </Box>
          </ListItemButton>
        </MenuItem>
        <Box sx={{
          fontSize: '0.7rem',
          width: '180px',
          paddingLeft: '1rem',
        }}>
          {ts('software_version', 'version:')}
          { SOFTWARE_VERSION_NUMBER }
        </Box>
      </Menu>
  )
}